import React from 'react';
import { Text as RNText } from 'react-native';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { View } from '../../../View';
import { Text } from './Text';
export const List = ({ value, style }) => {
    const styles = useStyleSheet(getStyles);
    const { ordered } = style;
    return (React.createElement(View, { style: styles.container }, value.map((props, index) => {
        return props.type === 'list' ? (React.createElement(View, { key: index, style: styles.list },
            React.createElement(List, { value: props.value, style: props.style }))) : (React.createElement(View, { key: index, style: styles.row },
            ordered ? (React.createElement(RNText, { style: styles.order },
                index + 1,
                ".")) : (React.createElement(RNText, { style: styles.bullet }, "\u2022")),
            React.createElement(Text, { value: props.value, style: props.style, href: props.href })));
    })));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        width: '100%'
    },
    row: {
        flexDirection: 'row',
        alignItems: 'flex-start'
    },
    bullet: {
        lineHeight: size.I,
        marginRight: size.C,
        width: size.I,
        textAlign: 'center'
    },
    order: {
        lineHeight: size.I,
        marginRight: size.C,
        width: size.I,
        textAlign: 'right'
    },
    list: {
        paddingLeft: size.C + size.I
    }
}));
//# sourceMappingURL=List.js.map